export default() => {
	const input = document.querySelector('.js-search-input');
	const holder = document.querySelector('.js-search-holder');
	const request = document.querySelector('.search-header__request');

	if	(input && holder) {
		input.addEventListener('input', () => {
			//if input blank add class 
			if (input.value === '') {
				request.classList.add('search-header__request--hidden');
			} else {
				request.classList.remove('search-header__request--hidden');
			}

			holder.innerHTML = input.value;
		});
		
	}
}